import WarningContainer from 'components/WarningContainer';

const NoMatch = () => {
	return <WarningContainer warningText="Ներեցեք, ձեր այցելած էջը գոյություն չունի:" />;
};

export default NoMatch;
